export default __webpack_public_path__ + "static/media/logo.fc3676a1.png";